export default __webpack_public_path__ + "static/media/wellness.03d00a14.svg";